import {
  CuePointsRequest,
  CuePointsResponse,
  Storyboard,
  TChapters,
} from "pages/media/types";
import { useCallback, useMemo } from "react";
import { useCustomMutation } from "@refinedev/core";

export const useFetchChaptersWithCuepoints = (timingChapters?: TChapters[]) => {
  const { mutateAsync: fetchNewCuepoints } =
    useCustomMutation<CuePointsResponse>();

  const timingChaptersWithSubtitles = useMemo(() => {
    return timingChapters?.filter((chapter) => chapter.subtitles);
  }, [timingChapters]);

  const fetchChaptersWithCuepoints = useCallback(
    async (storyboardWithHighlightTags: Storyboard) => {
      if (!timingChaptersWithSubtitles) return;

      const values: CuePointsRequest = {
        chapters: storyboardWithHighlightTags.sections.map(
          (section, index) => ({
            chapter_name: section.topic,
            chapter_text: section.script.content,
            chapter_start_timestamp:
              timingChaptersWithSubtitles[index]?.start_timestamp ?? 0,
            timestamped_words: {
              words: timingChaptersWithSubtitles[index]?.subtitles?.words ?? [],
            },
          })
        ),
      };

      try {
        console.debug("fetching cuepoints");
        const response = await fetchNewCuepoints({
          url: "media/media/cuepoints",
          method: "post",
          values,
        });

        return response?.data?.chapters;
      } catch (error) {
        console.error("Error fetching new cuepoints...", error);
      }
    },
    [timingChaptersWithSubtitles, fetchNewCuepoints]
  );
  return fetchChaptersWithCuepoints;
};
